import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  activeClass: { _invalid: true }
};

const getters = {
  activeClass(state) {
    return state.activeClass;
  }
};

const mutations = {
  setActiveClass(state, data) {
    state.activeClass = data;
  }
};

const actions = {
  async createClass(_, classObject) {
    const response = await axios.post('/blade/classes', classObject);
    return response.data.classObject;
  },
  async getClasses() {
    const response = await axios.get('/blade/classes');
    return response.data.classes;
  },
  async getMyClasses(_, { getAll }) {
    const response = await axios.get(`/blade/classes/me${getAll ? '?getAll=true' : ''}`);
    return response.data.classes;
  },
  async getClass(_, { classId }) {
    const { data } = await axios.get(`/blade/classes/${classId}`);
    return data;
  },
  async getActiveClass(context) {
    const endpoint = '/blade/classActive';
    const { data } = await axios.get(endpoint);
    context.commit('setActiveClass', data.classObject);
    return data.classObject;
  },
  async getClassTypes() {
    const { data } = await axios.get('/blade/classTypes');
    return data;
  },
  async getClassEnums() {
    const { data } = await axios.get('/blade/classEnums');
    return data;
  },
  async updateClass(_, classObject) {
    const response = await axios.patch(`/blade/classes/${classObject._id}`, classObject);
    return response.data.classObject;
  },
  async deleteClass(_, { classId }) {
    const response = await axios.delete(`/blade/classes/${classId}`);
    return response.data.classObject;
  },
  async getClassAdditionalUserFields(_, { classId }) {
    const response = await axios.get(`/blade/classes/${classId}/additionalFields`);
    return response.data.fields;
  },
  async getClassesByGame(_, { gameId }) {
    const { data } = await axios.get(`/blade/games/${gameId}/classes`);
    return data;
  },
  async getPlaythroughReport(_, { classId, userId }) {
    const response = await axios.get(`/blade/classes/${classId}/playthroughreport/${userId}`);
    return response.data.playthrough;
  },
  async copyUsersAndPlaythroughsToClass(_, { sourceClassId, destClassId, unsafe, emailFilter }) {
    const { data } = await axios.post(`/blade/classes/${sourceClassId}/copyUsersAndPlaythroughs/${destClassId}`, { unsafe, emailFilter });
    return data;
  },
  async generateClassInvite(_, classObject) {
    const response = await axios.patch(`/blade/classes/invite/${classObject._id}`);
    return response.data.game;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/classes.js